import { useSwitch } from "@huse/boolean";
import { Modal } from "antd";
import React, { forwardRef, useImperativeHandle } from "react";
import styles from "./index.module.less";
import { CloseCircleOutlined } from "@ant-design/icons";
import ClassNames from "classnames";

export interface ContactModalRef {
  open: () => void;
}

interface ContactModalProps {}

const ContactModal = forwardRef<ContactModalRef, ContactModalProps>(
  (_, ref) => {
    const [visible, open, close] = useSwitch(false);

    useImperativeHandle(ref, () => ({
      open,
    }));

    return (
      <Modal
        className={styles.modal}
        width="28.125vw"
        visible={visible}
        footer={null}
        closeIcon={<CloseCircleOutlined style={{ color: "white" }} />}
        onCancel={close}
      >
        <div className={ClassNames(styles.body, styles.left)}>
          <h1 className={styles.title}>欢迎咨询！</h1>
          <span className={styles.subtitle}>我们将竭诚为您服务！</span>
          <img
            src={require("assets/images/contact/contact.png")}
            alt="欢迎咨询！"
          />
        </div>
        <div className={ClassNames(styles.body, styles.right)}>
          <img
            className={styles.qrcode}
            src={require("assets/images/contact/manager_qrcode.jpg")}
            alt=""
          />
          <span className={styles.name}>银风科技商务经理</span>
          <span className={styles.phone}>联系电话：18826240825</span>
        </div>
      </Modal>
    );
  }
);

export default ContactModal;
